module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticStyle: {
      "position": "fixed"
    },
    attrs: {
      "dense": ""
    }
  }, [_c('v-btn', {
    staticClass: "orange darken-2 white--text",
    nativeOn: {
      "click": function($event) {
        return _vm.terugClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("arrow_back")]), _vm._v("Terug")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue white--text",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.afdrukkenClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("print")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "green white--text",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.opslaanClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("save")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red white--text",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.verwijderenClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center elevation-12",
    staticStyle: {
      "width": "90%",
      "min-width": "400px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "20px",
      "margin-bottom": "20px",
      "padding": "10px"
    }
  }, [(_vm.loading) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "120px",
      "height": "120px",
      "margin": "auto",
      "padding-top": "20px",
      "padding-left": "20px"
    }
  }, [_c('v-progress-circular', {
    staticClass: "orange--text",
    attrs: {
      "indeterminate": "",
      "size": 80,
      "width": 5
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('v-layout', {
    staticStyle: {
      "margin": "auto",
      "padding": "auto",
      "margin-right": "0px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "margin-bottom": "20px"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin": "0px",
      "height": "20px",
      "font-size": "10px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.wijzigvolgnrClicked($event)
      }
    }
  }, [_vm._v("wijzig volgnr")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.werfnr) + "\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "input": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.werfnaam),
      callback: function($$v) {
        _vm.werfnaam = $$v
      },
      expression: "werfnaam"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), (_vm.aantalmachines != 0) ? _c('v-flex', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px",
      "font-weight": "bold"
    },
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("Materieel:")]) : _vm._e(), _vm._v(" "), (_vm.aantalmachines != 0) ? _c('table', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('tbody', _vm._l((_vm.machines), function(item) {
    return _c('tr', {
      on: {
        "click": function($event) {
          return _vm.clickedMachine(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.soortID) + "." + _vm._s(item.volgnr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.omschr))])])
  }), 0)]) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "350px",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showSaveDialog),
      callback: function($$v) {
        _vm.showSaveDialog = $$v
      },
      expression: "showSaveDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Wijzigingen opslaan?")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveDialogOpslaan($event)
      }
    }
  }, [_vm._v("Opslaan")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveDialogNietOpslaan($event)
      }
    }
  }, [_vm._v("Niet opslaan")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveDialogAnnuleren($event)
      }
    }
  }, [_vm._v("Annuleren")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "350px",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showVerwijderDialog),
      callback: function($$v) {
        _vm.showVerwijderDialog = $$v
      },
      expression: "showVerwijderDialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "background-color": "red"
    }
  }, [_c('v-card-title', [_c('div', {
    staticClass: "headline white--text"
  }, [_vm._v("Werf verwijderen?")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showVerwijderDialog = false
      }
    }
  }, [_vm._v("Annuleren")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.verwDialogVerwijderen($event)
      }
    }
  }, [_vm._v("Verwijderen")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "350px",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showVerwijderDialogMislukt),
      callback: function($$v) {
        _vm.showVerwijderDialogMislukt = $$v
      },
      expression: "showVerwijderDialogMislukt"
    }
  }, [_c('v-card', {
    staticStyle: {
      "background-color": "orange"
    }
  }, [_c('v-card-title', [_c('div', {
    staticClass: "headline white--text"
  }, [_vm._v("Fout: werf bevat materieel")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showVerwijderDialogMislukt = false
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "350px",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showWijzigVolgnrDialog),
      callback: function($$v) {
        _vm.showWijzigVolgnrDialog = $$v
      },
      expression: "showWijzigVolgnrDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Wijzig werfnummer")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "werfnummer",
      "required": ""
    },
    model: {
      value: (_vm.werfnrnieuw),
      callback: function($$v) {
        _vm.werfnrnieuw = $$v
      },
      expression: "werfnrnieuw"
    }
  }), _vm._v(" "), (_vm.TErrorShow) ? _c('div', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.TErrorWijzigVolgnr))]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showWijzigVolgnrDialog = false
      }
    }
  }, [_vm._v("Annuleren")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.WijzigVolgnrDialogClicked($event)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0178a11d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/wervendetail.vue
// module id = 42
// module chunks = 3